import React from "react";
import { motion } from "framer-motion";

/**
 * Hero animated background:
 *  - Subtle line grid (CSS) with radial fade mask
 *  - 2-3 slow drifting blurred green orbs
 *  - Soft noise overlay
 */
export const AnimatedGrid = () => {
    return (
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
            <div className="zen-grid" />

            {/* Central soft accent glow */}
            <motion.div
                aria-hidden
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 2.4, ease: "easeOut" }}
                className="absolute left-1/2 top-1/2 h-[640px] w-[640px] -translate-x-1/2 -translate-y-1/2 rounded-full"
                style={{
                    background:
                        "radial-gradient(circle, rgba(124,255,79,0.10) 0%, rgba(124,255,79,0.04) 30%, transparent 65%)",
                    filter: "blur(80px)",
                }}
            />

            {/* Drifting orbs */}
            <motion.div
                aria-hidden
                animate={{ x: [0, 60, -20, 0], y: [0, -40, 30, 0] }}
                transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -left-20 top-1/3 h-[420px] w-[420px] rounded-full"
                style={{
                    background: "rgba(124,255,79,0.05)",
                    filter: "blur(120px)",
                }}
            />
            <motion.div
                aria-hidden
                animate={{ x: [0, -50, 30, 0], y: [0, 50, -20, 0] }}
                transition={{ duration: 26, repeat: Infinity, ease: "easeInOut" }}
                className="absolute right-0 bottom-0 h-[480px] w-[480px] rounded-full"
                style={{
                    background: "rgba(124,255,79,0.04)",
                    filter: "blur(140px)",
                }}
            />
            <motion.div
                aria-hidden
                animate={{ x: [0, 30, -40, 0], y: [0, -20, 40, 0] }}
                transition={{ duration: 30, repeat: Infinity, ease: "easeInOut" }}
                className="absolute right-1/4 top-10 h-[280px] w-[280px] rounded-full"
                style={{
                    background: "rgba(180,200,255,0.025)",
                    filter: "blur(100px)",
                }}
            />

            {/* Top + bottom dark fades for elegance */}
            <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[var(--bg-base)] to-transparent" />
            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[var(--bg-base)] to-transparent" />

            <div className="zen-noise" />
        </div>
    );
};

export default AnimatedGrid;
